module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/golden_pin_design_award_logo-b-e8afb790290a13b0e83562782ffe8c3d.svg&quot;;"